import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAbTestVoid = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 190 190",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			d: "M95.036 159.768C130.687 159.768 159.588 130.867 159.588 95.2165C159.588 59.5654 130.687 30.6646 95.036 30.6646C59.385 30.6646 30.4841 59.5654 30.4841 95.2165C30.4841 130.867 59.385 159.768 95.036 159.768Z",
			fill: "#005BE4"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			d: "M95 175.57C139.497 175.57 175.57 139.497 175.57 95C175.57 50.5027 139.497 14.4304 95 14.4304C50.5027 14.4304 14.4304 50.5027 14.4304 95C14.4304 139.497 50.5027 175.57 95 175.57Z",
			fill: "#005BE4"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			d: "M95 190C147.467 190 190 147.467 190 95C190 42.533 147.467 0 95 0C42.533 0 0 42.533 0 95C0 147.467 42.533 190 95 190Z",
			fill: "#005BE4"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_3335_21577",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 30,
			y: 30,
			width: 130,
			height: 130,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M95.036 159.768C130.687 159.768 159.588 130.867 159.588 95.2165C159.588 59.5654 130.687 30.6646 95.036 30.6646C59.385 30.6646 30.4841 59.5654 30.4841 95.2165C30.4841 130.867 59.385 159.768 95.036 159.768Z",
				fill: "#005BE4"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_3335_21577)",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 115,
					cy: 47,
					r: 2,
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 78,
					cy: 43,
					r: 2,
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 97,
					cy: 63,
					r: 2,
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 55,
					cy: 110,
					r: 2,
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 84.5,
					cy: 78.5,
					r: 4.5,
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 97.5,
					cy: 40.5,
					r: 4.5,
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 53.5,
					cy: 65.5,
					r: 4.5,
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 57,
					cy: 84,
					r: 2,
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 74,
					cy: 103,
					r: 2,
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M139.163 74.8378C139.163 74.8378 146 76.5285 146 78.0009C146 79.4734 139.163 81.1641 139.163 81.1641C139.163 81.1641 137.473 88.0009 136 88.0009C134.528 88.0009 133.177 81.1641 132.837 81.1641C132.497 81.1641 126 79.4734 126 78.0009C126 76.5285 132.837 74.8378 132.837 74.8378C132.837 74.8378 134.528 68.0009 136 68.0009C137.473 68.0009 139.163 74.8378 139.163 74.8378Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M105.163 139.838C105.163 139.838 112 141.528 112 143.001C112 144.473 105.163 146.164 105.163 146.164C105.163 146.164 103.473 153.001 102 153.001C100.528 153.001 99.1774 146.164 98.837 146.164C98.4966 146.164 92.0001 144.473 92.0001 143.001C92.0001 141.528 98.837 139.838 98.837 139.838C98.837 139.838 100.528 133.001 102 133.001C103.473 133.001 105.163 139.838 105.163 139.838Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M73.2398 137.761C73.2398 137.761 77.0001 138.691 77.0001 139.501C77.0001 140.31 73.2398 141.24 73.2398 141.24C73.2398 141.24 72.3099 145.001 71.5001 145.001C70.6902 145.001 69.9476 141.24 69.7603 141.24C69.5731 141.24 66.0001 140.31 66.0001 139.501C66.0001 138.691 69.7603 137.761 69.7603 137.761C69.7603 137.761 70.6902 134.001 71.5001 134.001C72.3099 134.001 73.2398 137.761 73.2398 137.761Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M149.24 112.761C149.24 112.761 153 113.691 153 114.501C153 115.31 149.24 116.24 149.24 116.24C149.24 116.24 148.31 120.001 147.5 120.001C146.69 120.001 145.948 116.24 145.76 116.24C145.573 116.24 142 115.31 142 114.501C142 113.691 145.76 112.761 145.76 112.761C145.76 112.761 146.69 109.001 147.5 109.001C148.31 109.001 149.24 112.761 149.24 112.761Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M114.24 82.7608C114.24 82.7608 118 83.6907 118 84.5005C118 85.3104 114.24 86.2402 114.24 86.2402C114.24 86.2402 113.31 90.0005 112.5 90.0005C111.69 90.0005 110.948 86.2402 110.76 86.2402C110.573 86.2402 107 85.3104 107 84.5005C107 83.6907 110.76 82.7608 110.76 82.7608C110.76 82.7608 111.69 79.0005 112.5 79.0005C113.31 79.0005 114.24 82.7608 114.24 82.7608Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M120.77 111.231C120.77 111.231 130 113.513 130 115.501C130 117.489 120.77 119.771 120.77 119.771C120.77 119.771 118.488 129.001 116.5 129.001C114.512 129.001 112.689 119.771 112.23 119.771C111.77 119.771 103 117.489 103 115.501C103 113.513 112.23 111.231 112.23 111.231C112.23 111.231 114.512 102.001 116.5 102.001C118.488 102.001 120.77 111.231 120.77 111.231Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M137 46L44 139H44.5H45.5L139 48L137 46Z",
					fill: "white"
				})
			]
		})
	]
});
export default SvgAbTestVoid;
